<!-- Daily Rank -->
<template>
  <div class="dr-list-page">
    <div class="main-grid-section">
      <!-- 예비사업주 리스트 그리드 -->
      <ag-grid-vue
        v-show="activeFilter === 'list'"
        class="ag-dr-balham"
        :style="{ width: '100%', height: gridHeight + 'rem' }"
        :columnDefs="pboListColumnDefs"
        :rowData="pboListData"
        :gridOptions="pboListGridOptions"
        :theme="sideTheme"
      />

      <!-- 본부 그리드 -->
      <ag-grid-vue
        v-show="activeFilter === 'branch'"
        class="ag-dr-balham"
        :style="{ width: '100%', height: gridHeight + 'rem' }"
        :columnDefs="branchColumnDefs"
        :rowData="branchData"
        :gridOptions="branchGridOptions"
        :theme="branchTheme"
        :rowHeight="rowHeight"
        @grid-ready="onBranchGridReady"
      />

      <!-- 전체 그리드 부분 -->
      <div
        class="info-label"
        v-show="activeFilter === 'all'"
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <input
          type="text"
          placeholder="검색"
          @input="onQuickFilterChanged"
          style="
            width: 15%;
            height: 3%;
            padding: 5px;
            border-radius: 5px;
            border: 1px solid #ccc;
            font-size: 0.9rem;
          "
        />
        점포검색
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            flex: 1;
          "
        >
          <span>{{ filterLabel }}</span>
        </div>
      </div>
      <ag-grid-vue
        v-show="activeFilter === 'all'"
        class="ag-dr-balham all-grid"
        :style="{ width: '100%', height: gridHeight - 1.8 + 'rem' }"
        :columnDefs="allColumnDefs"
        :rowData="allData"
        :gridOptions="allGridOptions"
        :theme="branchTheme"
        :context="{ componentParent: this }"
        @grid-ready="onGridReady"
        :rowHeight="rowHeight"
      />
    </div>
    <div class="side-section">
      <div class="button-container">
        <div class="button-row">
          <button
            :class="[
              'filter-btn prospective-business',
              { active: activeFilter === 'list' },
            ]"
            @click="changeFilter('list')"
          >
            예비사업주 리스트
          </button>
          <button
            v-if="isSaveButtonVisible"
            :class="[
              'achievement-btn prospective-business',
              { active: showAchievement },
            ]"
            @click="toggleAchievement"
          >
            예비사업주 관리
            <DrListPopPage v-if="showPopup" @close="closePopup" />
          </button>
        </div>
        <div class="button-row">
          <button
            :class="['filter-btn', { active: activeFilter === 'branch' }]"
            @click="changeFilter('branch')"
          >
            본부
          </button>
          <button
            :class="['filter-btn', { active: activeFilter === 'all' }]"
            @click="changeFilter('all')"
          >
            전체
          </button>
        </div>
        <div class="button-row">
          <button
            :class="[
              'filter-btn',
              {
                active:
                  ['SHOP_RANK_2'].includes(activeBranchType) &&
                  (activeFilter === 'branch' || activeFilter === 'all'),
              },
            ]"
            @click="changeMetric('daily')"
          >
            당일수량
          </button>
          <button
            :class="[
              'filter-btn',
              {
                active:
                  ['SHOP_RANK_GROUTHRANK_2'].includes(activeBranchType) &&
                  (activeFilter === 'branch' || activeFilter === 'all'),
              },
            ]"
            @click="changeMetric('rate')"
          >
            달성률
          </button>
        </div>
        <div class="button-row" v-if="isBranchManager && activeFilter === 'branch'">
          <button
            class="filter-btn"
            style="background-color: #fff9c4; font-weight: bold; border: 1px solid #fbc02d;"
            @click="copyBranchData"
          >
            본부 데이터 복사
          </button>
        </div>
        <div class="button-row">
          <button
            class="filter-btn"
            style="background-color: #c0c0ff; cursor: default"
          >
            단순수량달성률
          </button>
        </div>
      </div>
      <div class="achievement-section">
        <ag-grid-vue
          class="ag-dr-balham achievement-grid"
          :style="{ width: '100%', height: gridHeight - 7.3 + 'rem' }"
          :columnDefs="achievementRateColumnDefs"
          :rowData="achievementRateData"
          :gridOptions="achievementRateGridOptions"
          :theme="sideTheme"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue3";
import axios from "axios";
import "ag-grid-community/styles/ag-grid.css";
import { themeBalham } from "ag-grid-community";
import DrListPopPage from "./DrListPopPage.vue";

export default {
  name: "DrListPage",
  components: {
    AgGridVue,
    DrListPopPage,
  },
  data() {
    return {
      userInfo: null, // 로그인한 사용자 정보

      totalRankData: [],

      rowHeight: window.innerWidth > 1024 ? 18 : 15, // 행 높이

      gridHeight: window.innerWidth > 1024 ? 50 : 42.5, // 그리드 높이

      activeFilter: "list", // 기본값: 예비사업주 리스트
      showAchievement: false,
      showPopup: false,
      activeBranchType: "SHOP_RANK_2",
      blinkOn: false, // 깜빡임 상태를 제어하기 위한 데이터 속성
      filterBranchCd: null, // 본부 필터링을 위한 CD
      filterLabel: "",
      quickFilterText: "",

      // 그리드 복사 추가
      branchGridApi: null,

      branchTheme: themeBalham.withParams({
        fontFamily: "Malgun Gothic",
        wrapperBorder: true,
        headerRowBorder: true,
        headerColumnBorderHeight: '100%',
        rowBorder: { style: "solid", width: 1 },
        columnBorder: { style: "solid", width: 1 },
      }),

      sideTheme: themeBalham.withParams({
        fontFamily: "Malgun Gothic",
        headerHeight: 40,
        rowHeight: 25,
        borderColor: "#808080",
        wrapperBorder: true,
        headerRowBorder: true,
        headerColumnBorderHeight: '100%',
        rowBorder: { style: "solid", width: 1 },
        columnBorder: { style: "solid", width: 1 },
      }),

      regions: [
        { code: "01", name: "강원" },
        { code: "02", name: "북부" },
        { code: "03", name: "경인" },
        { code: "04", name: "분당" },
        { code: "05", name: "천안" },
        { code: "06", name: "대전" },
        { code: "07", name: "호남" },
        { code: "08", name: "남해" },
        { code: "09", name: "부산" },
        { code: "10", name: "경북" },
        // { code: "11", name: "중부제주" },
      ],

      // 예비사업주 그리드 관련
      pboListData: [], // API에서 받아올 달성률 데이터
      pboListColumnDefs: [], // 초기에는 빈 배열
      pboListGridOptions: {
        groupHeaderHeight: 20,
        headerHeight: 30,
        defaultColDef: {
          wrapHeaderText: true,
          resizable: true,
          sortable: false,
          headerStyle: {
            color: "black",
            backgroundColor: "#87a9e9",
          },
        },
        rowSelection: { mode: "singleRow", checkboxes: false },
        suppressDragLeaveHidesColumns: true, // 드래그 후 열 숨기기 방지
      },

      // 본부 그리드 관련
      branchData: [],
      branchColumnDefs: [],
      branchGridOptions: {
        groupHeaderHeight: 18,
        headerHeight: 30,
        tooltipShowMode: "whenTruncated",
        enableBrowserTooltips: false,
        tooltipShowDelay: 0,
        defaultColDef: {
          wrapHeaderText: true,
          resizable: true,
          sortable: false,
          tooltipValueGetter: (params) => params.value,
          headerStyle: {
            color: "black",
            backgroundColor: "#87a9e9",
          },
        },
        rowSelection: { mode: "singleRow", checkboxes: false },
        suppressDragLeaveHidesColumns: true, // 드래그 후 열 숨기기 방지
      },

      // 전체 그리드 관련
      allData: [], // 80개씩 분할된 데이터
      // allColumnDefs: [], computed 로 옮김
      allGridOptions: {
        suppressHorizontalScroll: true,
        headerHeight: 16,
        tooltipShowMode: "whenTruncated",
        enableBrowserTooltips: false,
        tooltipShowDelay: 0,
        defaultColDef: {
          resizable: true,
          sortable: false, // 순위가 이미 정해져 있으므로 정렬 비활성화
          // 툴팁에 표시할 값을 설정합니다.
          tooltipValueGetter: (params) => params.value,
          headerStyle: {
            color: "black",
            textAlign: "center",
          },
        },
        suppressDragLeaveHidesColumns: true, // 드래그 후 열 숨기기 방지
      },

      // 단순 수량 달성률 그리드 관련
      achievementRateData: [], // API에서 받아올 달성률 데이터
      achievementRateColumnDefs: [
        {
          headerName: "",
          field: "BRANCH_CD",
          hide: true, // 숨김 컬럼
        },
        {
          headerName: "순위",
          field: "MONTH_RANK",
          flex: 0.3,
          cellStyle: this.getAchievementRateCellStyle,
        },
        {
          headerName: "본\n부",
          field: "BRANCH_NM",
          flex: 0.8,
          onCellDoubleClicked: this.showBranchDetails,
          cellStyle: this.getAchievementRateCellStyle,
          tooltipValueGetter: (params) => {
            return params.value + " 더블 클릭 시 해당 본부 조회";
          },
        },
        {
          headerName: "당일\n수량",
          field: "TODAY_SALE_QTY",
          flex: 0.9,
          cellStyle: this.getAchievementRateCellStyle,
        },
        {
          headerName: "당일\n평균",
          field: "TODAY_SALE_QTY_EVR",
          flex: 0.9,
          valueFormatter: (params) => {
            return Number(params.value).toFixed(1);
          },
          cellStyle: this.getAchievementRateCellStyle,
        },
        {
          headerName: "달성률",
          field: "MONTH_GOAL_RATE",
          flex: 1.3,
          valueFormatter: (params) => {
            return Number(params.value) + "%";
          },
          cellStyle: this.getAchievementRateCellStyle,
        },
        {
          headerName: "차이",
          field: "DIFF",
          flex: 0.9,
          valueGetter: (params) => {
            const monthGoalRate = params.data.MONTH_GOAL_RATE;
            let maxMonthGoalRate =
              params.api.getDisplayedRowAtIndex(0).data.MONTH_GOAL_RATE;
            params.api.forEachNode((node) => {
              if (node.data && node.data.MONTH_GOAL_RATE != null) {
                maxMonthGoalRate = Math.max(
                  maxMonthGoalRate,
                  node.data.MONTH_GOAL_RATE
                );
              }
            });
            return Number(maxMonthGoalRate - monthGoalRate).toFixed(1);
          },
          cellStyle: this.getAchievementRateCellStyle,
        },
      ],

      achievementRateGridOptions: {
        enableBrowserTooltips: false,
        tooltipShowDelay: 0,
        defaultColDef: {
          wrapHeaderText: true,
          resizable: true,
          sortable: false,
          headerStyle: {
            color: "black",
            textAlign: "center",
          },
        },
        rowSelection: { mode: "singleRow", checkboxes: false },
        suppressDragLeaveHidesColumns: true, // 드래그 후 열 숨기기 방지
      },

      rowData: [], // API에서 받아올 데이터

      branchColors: {
        "01": "#ffc3c6", // 강원 (255,195,198)
        "02": "#ff8284", // 북부 (255,130,132)
        "03": "#ff0000", // 경인 (255,0,0)
        "04": "#ffff00", // 분당 (255,255,0)
        "05": "#ffc384", // 천안 (255,195,132)
        "06": "#ff8200", // 대전 (255,130,0)
        "07": "#73f089", // 호남 (115,240,137)
        "08": "#ffff84", // 남해 (255,255,132)
        "09": "#ffe3c6", // 부산 (255,227,198)
        "10": "#c6ffc6", // 경북 (198,255,198)
        "11": "#C9B59C", // 중부제주
        default: "#00ffff", // 그 외 (0,255,255)
      },

      commonHeaderStyle: {
        color: "black",
        backgroundColor: "#87a9e9",
        textAlign: "center",
        fontWeight: "normal",
      },

    };
  },

  watch: {
    totalRankData(totalData) {
      // totalData에 유효한 값이 들어왔을 때만 이벤트를 발생
      if (totalData && Object.keys(totalData).length > 0) {
        const topTranData = {
          shopName: this.userInfo?.SHOP_NM || "본사로그인",
          telNo: this.userInfo?.TEL_NO,
        };

        if (this.userInfo?.OGN_FG == "00") {
          topTranData.drTotalRankData = totalData;
        }
        this.$emit("top-info-change", topTranData);
      }
    },
  },

  mounted() {
    this.pboListColumnDefs = [
      {
        headerName: "",
        field: "rowIndex",
        flex: 0.1,
        valueGetter: "node.rowIndex + 1",
        sortable: false,
        cellStyle: {
          color: "black",
          "background-color": "#87a9e9",
          "text-align": "center",
        },
      },
      ...this.regions.map((region) => ({
        headerName: region.name,
        headerStyle: this.commonHeaderStyle,
        children: [
          {
            headerName: "이름",
            field: `${region.code}_NAME`,
            cellStyle: this.commonCellStyle,
            flex: 0.8,
          },
          {
            headerName: "경\n력",
            field: `${region.code}_CAREER`,
            cellStyle: this.commonCellStyle,
            flex: 0.3,
          },
        ],
      })),
    ];

    this.branchColumnDefs = [
      {
        headerName: "",
        field: "rowIndex",
        flex: 0.1,
        valueGetter: "node.rowIndex + 1",
        sortable: false,
        cellStyle: {
          color: "black",
          "background-color": "#87a9e9",
          "text-align": "center",
        },
      },
      ...this.regions.map((region) => ({
        headerName: region.name,
        headerStyle: this.commonHeaderStyle,
        children: [
          {
            headerName: "이름",
            field: `${region.code}_SHOP_NM`,
            // cellStyle: this.commonCellStyle,
            cellStyle: this.getBranchCellStyle,
            flex: 0.9,
          },
          {
            headerName: "수\n량",
            field: `${region.code}_SALE_QTY`,
            cellStyle: this.commonCellStyle,
            flex: 0.4,
            valueFormatter: (params) => {
              if (
                params.value === null ||
                params.value === undefined ||
                params.value === ""
              ) {
                return "";
              } else {
                return Math.round(Number(params.value));
              }
            },
          },
        ],
      })),
    ];

    const userInfoString = localStorage.getItem("userInfo");
    if (userInfoString) {
      this.userInfo = JSON.parse(userInfoString);
    }

    this.fetchPboListData();
    this.fetchAchievementData();
    this.fetchTotalRankData();
    this.startBlinking(); // 깜빡임 애니메이션 시작

    window.addEventListener("resize", this.handleResize);
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
    clearInterval(this.blinkInterval); // 컴포넌트 파괴 시 인터벌 정리
  },

  computed: {
    isBranchManager() {
      // return this.userInfo && ;
      return this.userInfo && (this.userInfo.EMP_CLASS_NM === '본부장' || ['판매전쟁실', '관리자팀'].includes(this.userInfo.EMP_DEPT_NM));
    },
    isSaveButtonVisible() {
      return (
        this.userInfo &&
        ["판매본부", "관리자팀"].includes(this.userInfo.EMP_DEPT_NM)
      );
    },
    allColumnDefs() {
      const isDaily = this.activeBranchType === "SHOP_RANK_2";
      const headerName = isDaily ? "수량" : "달성률";

      const valueFormatter = (params) => {
        if (params.value == null || params.value === "") {
          return "";
        }
        if (isDaily) {
          return Number(params.value).toLocaleString();
        } else {
          return Number(params.value);
        }
      };

      return [
        ...Array(7)
          .fill()
          .map((_, i) => [
            {
              headerName: "",
              field: `no${i + 1}_BRANCH_CD`,
              hide: true, // 숨김 컬럼
            },
            {
              headerName: "No.",
              field: `no${i + 1}_RANK`,
              flex: 0.4,
              cellStyle: { textAlign: "center" },
              cellClass: (params) => {
                // 검색어는 onQuickFilterChanged에서 이미 소문자로 변환되어 저장
                const classes = [];
                const filter = params.context.componentParent.quickFilterText;

                if (filter) {
                  const lowerFilter = filter.toLowerCase();

                  // 검색어가 "점명" 값에 포함되는지 확인
                  const shopName =
                    params.data?.[
                      `no${params.colDef.field.substring(2, 3)}_SHOP_NM`
                    ]
                      ?.toString()
                      .toLowerCase() ?? "";

                  if (shopName.includes(lowerFilter)) {
                    // 같은 행의 해당 칼럼이  RANK 이면 색칠
                    const field = params.colDef.field;
                    if (field.includes("_RANK")) {
                      classes.push("highlight-cell");
                    }
                  }
                }
                return classes;
              },
            },
            {
              headerName: "점명",
              field: `no${i + 1}_SHOP_NM`,
              flex: 0.7,
              cellStyle: this.getAllCellStyle,
              cellClass: (params) => {
                // 검색어는 onQuickFilterChanged에서 이미 소문자로 변환되어 저장
                const classes = [];
                const filter = params.context.componentParent.quickFilterText;

                if (filter) {
                  const lowerFilter = filter.toLowerCase();

                  // 현재 컬럼 값
                  const currentValue =
                    params.value?.toString().toLowerCase() ?? "";
                  if (currentValue.includes(lowerFilter)) {
                    classes.push("highlight-cell");
                  }
                }

                // return null;
                const isDaily = this.activeBranchType !== "SHOP_RANK_2";
                if (isDaily) {
                  const regionCode = params.colDef.field.substring(2, 3);
                  const saleQtyField = `no${regionCode}_SALE_QTY`;
                  const saleQtyValue = parseInt(params.data[saleQtyField], 10);
                  if (!isNaN(saleQtyValue) && saleQtyValue < 80) {
                    // JavaScript로 제어하므로 CSS 애니메이션 클래스 대신 상태 클래스 사용
                    classes.push("needs-blinking"); 
                    if (this.blinkOn) classes.push("blink-on");
                  }
                }
                return classes;
              },
            },
            {
              headerName: headerName,
              field: `no${i + 1}_SALE_QTY`,
              flex: 0.6,
              valueFormatter: valueFormatter,
              cellStyle: { textAlign: "right" },
              cellClass: (params) => {
                // 검색어는 onQuickFilterChanged에서 이미 소문자로 변환되어 저장
                const classes = [];
                const filter = params.context.componentParent.quickFilterText;

                if (filter) {
                  const lowerFilter = filter.toLowerCase();

                  // 검색어가 "점명" 값에 포함되는지 확인
                  const shopName =
                    params.data?.[
                      `no${params.colDef.field.substring(2, 3)}_SHOP_NM`
                    ]
                      ?.toString()
                      .toLowerCase() ?? "";

                  if (shopName.includes(lowerFilter)) {
                    // 같은 행의 해당 칼럼이 SALE_QTY이면 색칠
                    const field = params.colDef.field;
                    if (field.includes("_SALE_QTY")) {
                      classes.push("highlight-cell");
                    }
                  }
                }
                return classes;
              },
            },
          ])
          .flat(),
      ];
    },
  },

  methods: {
    changeFilter(filter) {
      this.filterBranchCd = null; // 필터 버튼 클릭 시 본부 필터 초기화
      this.activeFilter = filter;
      if (filter === "branch" || filter === "all") {
        this.fetchBranchData();
      } else if (filter === "list") {
        this.fetchPboListData();
      }
      this.updateFilterLabel();
    },
    // '당일수량', '달성률' 변경
    changeMetric(metric) {
      // '본부' '전체' 가 아닐 경우 동작하지 않음
      if (this.activeFilter !== "branch" && this.activeFilter !== "all") return;

      const metricMap = {
        daily: "SHOP_RANK_2",
        rate: "SHOP_RANK_GROUTHRANK_2",
      };
      this.activeBranchType = metricMap[metric];
      this.fetchBranchData();
      this.updateFilterLabel();
    },

    updateFilterLabel() {
      if (this.activeFilter !== "all") {
        this.filterLabel = "";
        return;
      }
      const now = new Date();
      const month = (now.getMonth() + 1).toString().padStart(2, "0");

      if (this.activeBranchType === "SHOP_RANK_2") {
        this.filterLabel = `(${month}월 당일판매 수량 순위)`;
      } else if (this.activeBranchType === "SHOP_RANK_GROUTHRANK_2") {
        this.filterLabel = `(${month}월 예상달성률 순위)`;
      } else {
        this.filterLabel = "";
      }
    },

    showBranchDetails(params) {
      const branchCd = params.data.BRANCH_CD;
      if (!branchCd) return;

      this.filterBranchCd = branchCd;

      this.fetchBranchData();
    },

    async fetchPboListData() {
      try {
        // API 호출 예시
        const res = await axios.get("/api/drListPage");
        const rawData = res.data;

        if (!Array.isArray(rawData)) {
          console.error("API 응답이 배열이 아닙니다.", rawData);
          this.pboListData = [];
          return;
        }

        // 데이터에서 가장 큰 ROW 값을 찾아 그리드의 행 수를 결정
        const maxRow = rawData.reduce(
          (max, item) => Math.max(max, parseInt(item.ROW, 10)),
          0
        );

        // 그리드 행 수만큼 빈 객체 배열을 생성
        const transformedData = Array.from({ length: maxRow + 5 }, () => ({}));

        // 원본 데이터를 순회하며 새로운 그리드 데이터 형식으로 변환
        rawData.forEach((item) => {
          const rowIndex = parseInt(item.ROW, 10) - 1;
          if (rowIndex >= 0 && rowIndex < maxRow) {
            const branchCd = item.BRANCH_CD;
            // 각 본부 코드와 컬럼(NAME, CAREER)을 조합하여 필드명을 만듬
            // 예: 01_NAME, 01_CAREER
            transformedData[rowIndex][`${branchCd}_NAME`] = item.NAME;
            transformedData[rowIndex][`${branchCd}_CAREER`] = item.CAREER;
          }
        });

        this.pboListData = transformedData;
      } catch (error) {
        console.error("데이터 로딩 실패:", error);
      }
    },

    async fetchBranchData() {
      // const res = await axios.get("/api/drListPage/fetchBranchData");
      const requestParams = {
        piSqlIndex: this.activeBranchType,
      };
      if (this.filterBranchCd) {
        requestParams.branchCd = this.filterBranchCd;
      }
      const res = await axios.get("/api/drListPage/fetchBranchData", {
        params: requestParams,
      });
      const rawData = res.data;
      if (!Array.isArray(rawData)) {
        console.error("API 응답이 배열이 아닙니다.", rawData);
        this.branchData = [];
        this.allData = [];
        return;
      }
      if (this.activeFilter === "branch") {
        //
        const branchMap = {};
        rawData.forEach((item) => {
          if (!branchMap[item.BRANCH_CD]) {
            branchMap[item.BRANCH_CD] = [];
          }
          branchMap[item.BRANCH_CD].push(item);
        });

        // 브랜치별로 순서대로 정렬 (RANK나 CAREER 기준)
        Object.keys(branchMap).forEach((cd) => {
          branchMap[cd].sort((a, b) => a.RANK - b.RANK);
        });

        // 가장 긴 브랜치 길이에 맞춰 행(row) 개수 확보
        const maxLen = Math.max(
          ...Object.values(branchMap).map((arr) => arr.length)
        );

        const rows = [];
        for (let i = 0; i < maxLen; i++) {
          const row = {};
          Object.keys(branchMap).forEach((cd) => {
            const item = branchMap[cd][i];
            if (item) {
              row[`${cd}_SHOP_NM`] = item.SHOP_NM;
              row[`${cd}_SALE_QTY`] = item.SALE_QTY;
            }
          });
          rows.push(row);
        }

        this.branchData = rows;
      } else if (this.activeFilter === "all") {
        const transformedData = [];
        const chunkSize = 80;
        const totalChunks = Math.ceil(rawData.length / chunkSize);

        // chunkSize개 단위로 끊어서 세트 만들기
        for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
          const chunk = rawData.slice(
            chunkIndex * chunkSize,
            (chunkIndex + 1) * chunkSize
          );

          // chunkSize행 기준으로 pivot
          chunk.forEach((item, rowIndex) => {
            if (!transformedData[rowIndex]) transformedData[rowIndex] = {};

            const groupNo = chunkIndex + 1; // 몇 번째 세트인지
            transformedData[rowIndex][`no${groupNo}_BRANCH_CD`] =
              item.BRANCH_CD;
            transformedData[rowIndex][`no${groupNo}_RANK`] = item.RANK;
            transformedData[rowIndex][`no${groupNo}_SHOP_NM`] = item.SHOP_NM;
            transformedData[rowIndex][`no${groupNo}_SALE_QTY`] = item.SALE_QTY;
          });
        }
        this.allData = transformedData;
      }
    },

    // async fetchAllData() {
    //   const res = await axios.get("/api/drListPage/fetchAllData");
    //   console.log(res.data);
    //   this.allData = res.data;
    // },

    async fetchAchievementData() {
      try {
        const res = await axios.get("/api/drListPage/fetchAchievementData");

        this.achievementRateData = res.data;
      } catch (error) {
        console.error("데이터 로딩 실패:", error);
      }
    },

    async fetchTotalRankData() {
      try {
        const res = await axios.get("/api/drListPage/fetchTotalRankData");

        this.totalRankData = res.data;
      } catch (error) {
        console.error("데이터 로딩 실패:", error);
      }
    },

    commonCellStyle(params) {
      const value = params.value;
      const style = {};
      const field = params.colDef.field;
      const regionNM = field.substring(field.length - 3);


      if (field) {
        const regionCode = field.substring(0, 2);
        const targetCodes = ["02", "04", "06", "08", "10"];

        if (targetCodes.includes(regionCode) && this.activeFilter !== "all") {
          style.backgroundColor = "#f0f0f0"; // AliceBlue 색상
        }
      }

      const isDaily = this.activeBranchType == "SHOP_RANK_2";
      if (isDaily || this.activeFilter === "list")  {
        if (params.rowIndex + 1 == 10) {
          style.backgroundColor = "#ffff80";
        } else if (params.rowIndex + 1 == 20) {
          style.backgroundColor = "#80ff80";
        } else if (params.rowIndex + 1 == 30) {
          style.backgroundColor = "#80ffff";
        } else if (params.rowIndex + 1 == 40) {
          style.backgroundColor = "#8080ff";
        } else if (params.rowIndex + 1 == 50) {
          style.backgroundColor = "#ffd2d2";
        }
      }

      if (regionNM == "AME") {
        style.textAlign = "center";
      } else {
        if (isNaN(value)) {
          style.textAlign = "left";
        } else {
          style.textAlign = "right";
        }
      }

      return style;
    },

    getBranchCellStyle(params) {
      const style = { textAlign: "left" }; // 이름 컬럼 기본 가운데 정렬

      const field = params.colDef.field;
      // if (!params.data || !field) return style;

      // 현재 '이름' 컬럼의 지역 코드를 사용하여 '경력' 컬럼의 필드명을 만듭니다.
      const regionCode = field.substring(0, 2);
      const saleQtyField = `${regionCode}_SALE_QTY`;
      const saleQtyValue = parseInt(params.data[saleQtyField], 10);
      
      // 경력 값에 따라 배경색을 설정합니다.
      const isDaily = this.activeBranchType !== "SHOP_RANK_2";
      if (!isDaily) {
        if (params.rowIndex + 1 == 10) {
          style.backgroundColor = "#ffff80";
        } else if (params.rowIndex + 1 == 20) {
          style.backgroundColor = "#80ff80";
        } else if (params.rowIndex + 1 == 30) {
          style.backgroundColor = "#80ffff";
        } else if (params.rowIndex + 1 == 40) {
          style.backgroundColor = "#8080ff";
        } else if (params.rowIndex + 1 == 50) {
          style.backgroundColor = "#ffd2d2";
        }
      }

      if (isNaN(saleQtyValue) && saleQtyField) {
        return style; // 경력 값이 없거나 숫자가 아니면 기본 스타일 반환
      }

      if (isDaily) {
        if (saleQtyValue >= 130) {
          style.backgroundColor = "#6096FB";
          // style.color = "white";
        } else if (saleQtyValue >= 100) {
          style.backgroundColor = "#FFFFFF";
        } else if (saleQtyValue >= 90) {
          style.backgroundColor = "#FFC3C6";
        } else if (saleQtyValue >= 80) {
          style.backgroundColor = "#FFFF00";
        } else {
          style.backgroundColor = "#FF0000";
        }
      }

      return style;
    },

    getAllCellStyle(params) {
      const style = { textAlign: "center" }; // 점명 컬럼 기본 가운데 정렬

      const field = params.colDef.field;
      if (!params.data || !field) return style;

      // 현재 '점명' 컬럼의 지역 코드를 사용하여  컬럼의 필드명을 만듭니다.
      const regionCode = field.substring(2, 3);
      const saleQtyField = `no${regionCode}_SALE_QTY`;
      const saleQtyValue = isNaN(parseInt(params.data[saleQtyField], 10))
        ? 0
        : parseInt(params.data[saleQtyField], 10);

      if (isNaN(saleQtyValue)) {
        return style; // 값이 없거나 숫자가 아니면 기본 스타일 반환
      }

      const branchCdField = `no${regionCode}_BRANCH_CD`;
      const branchCd = params.data[branchCdField];

      // 경력 값에 따라 배경색을 설정합니다.
      const isDaily = this.activeBranchType !== "SHOP_RANK_2";
      if (isDaily) {
        if (saleQtyValue >= 130) {
          style.backgroundColor = "#6096FB";
        } else if (saleQtyValue >= 100) {
          style.backgroundColor = "#FFFFFF";
        } else if (saleQtyValue >= 90) {
          style.backgroundColor = "#FFC3C6";
        } else if (saleQtyValue >= 80) {
          style.backgroundColor = "#FFFF00";
        } else {
          style.backgroundColor = "#FFFFFF";
        }
        return style;
      } else if (branchCd && this.branchColors[branchCd]) {
        style.backgroundColor = this.branchColors[branchCd];
        return style;
      }
    },

    getAchievementRateCellStyle(params) {
      // const year = params.data?.years;
      const branchCd = params.data?.BRANCH_CD;
      const value = params.value;
      const columnId = params.column.colId;

      const style = {};

      style.textAlign = "center";
      style.alignContent = "center";
      style.background = "#96c9e7";
      // const field = params.colDef.field;
      if (branchCd && this.branchColors[branchCd] && columnId == "BRANCH_NM") {
        style.backgroundColor = this.branchColors[branchCd];
      }

      if (isNaN(value) || params.colDef.field == "MONTH_RANK") {
        style.textAlign = "center";
      } else {
        style.textAlign = "right";
      }

      if (columnId == "MONTH_GOAL_RATE") {
        style.color = "#d33";
      }

      if (columnId == "DIFF") {
        if (value > 0) {
          style.color = "#f80639";
        } else {
          style.color = "#0617f8";
        }
      }

      return style;
    },

    onGridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
    },

    onQuickFilterChanged(event) {
      // 검색어를 소문자로 변환하여 저장합니다. (cellClass에서 반복적인 변환 방지)
      this.quickFilterText = event.target.value.toLowerCase();
      if (this.gridApi) {
        this.gridApi.setGridOption("quickFilterText", this.quickFilterText); // quickFilter 적용

        this.gridApi.refreshCells({ force: true });
      } else {
        console.error("Grid API is not initialized.");
      }
    },

    toggleAchievement() {
      this.showAchievement = true;
      this.showPopup = true;
    },
    closePopup() {
      this.showPopup = false;
      this.showAchievement = false;
      this.fetchPboListData();
    },
    
    startBlinking() {
      this.blinkInterval = setInterval(() => {
        this.blinkOn = !this.blinkOn;
        // 'all' 탭이 활성화되어 있을 때만 그리드 새로고침
        if (this.activeFilter === 'all' && this.gridApi) {
          this.gridApi.refreshCells({ force: true });
        }
      }, 1000); // 1초 간격으로 깜빡임 (2초 주기)
    },

    handleResize() {
      const isWide = window.innerWidth > 1024;
      const newRowHeight = isWide ? 18 : 15;
      const newGridHeight = isWide ? 50 : 42.5;
      if (this.rowHeight !== newRowHeight) {
        this.rowHeight = newRowHeight;
        if (this.gridApi) this.gridApi.resetRowHeights();
      }
      if (this.gridHeight !== newGridHeight) {
        this.gridHeight = newGridHeight;
      }
    },
    onBranchGridReady(params) {
      this.branchGridApi = params.api;
    },

    copyBranchData() {
      this.copyData(this.branchGridApi);
    },
    
    copyData(gridApi) {
      const csvData = gridApi.getDataAsCsv({
        // 헤더 가공: \n 제거
        processHeaderCallback: (params) => {
          const def = params.column.getColDef();
          const header = def.headerName ?? def.field ?? "";
          return String(header).replace(/\r?\n/g, " "); // 줄바꿈 → 공백
        },
        // 셀 값 가공(필요하면): 셀 안의 줄바꿈도 제거
        processCellCallback: (params) => {
          const v = params.value;
          if (v == null) return "";
          return String(v).replace(/\r?\n/g, " ");
        },
        // 엑셀 친화 옵션
        columnSeparator: "\t", // 탭 구분 → 엑셀에 바로 셀 분리
        suppressQuotes: true, // 큰따옴표 억제(헤더에 따옴표 생기는 문제 방지)
      });

      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(csvData)
          .then(() => alert("복사되었습니다."))
          .catch((err) => console.error("Clipboard copy failed: ", err));
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = csvData;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        alert("복사되었습니다.");
      }
    },
  },
};
</script>

<style scoped>
.dr-list-page {
  display: flex;
  flex-direction: row;
  padding: 2px;
  gap: 2px;
}

.main-grid-section {
  flex: 8; /* 80% */
}

.side-section {
  flex: 2; /* 20% */
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  gap: 2px;
}

.button-container {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.button-row {
  display: flex;
  gap: 2px;
}

.button-row button {
  flex: 1; /* Make buttons in a row have equal width */
}

.filter-btn,
.achievement-btn {
  padding: 3px 0px;
  border: 1px solid #808080;
  background: white;
  cursor: pointer;
  box-sizing: border-box;
  font-size: 0.85rem;
}

.prospective-business {
  font-size: 0.75rem;
}

.filter-btn.active {
  background: #4caf50;
  color: white;
  border-color: #4caf50;
}

.achievement-btn.active {
  background: #2196f3;
  color: white;
  border-color: #2196f3;
}

.achievement-section {
  flex-grow: 1; /* Takes remaining space */
}

:deep(.ag-dr-balham) {
  font-family: "Malgun Gothic", Arial, sans-serif;
  --ag-cell-horizontal-padding: 2px; /* 셀 내부 좌우 패딩 */
  --ag-cell-vertical-padding: 1px; /* 셀 내부 상하 패딩 */
}

:deep(.ag-dr-balham .ag-header-cell-comp-wrapper) {
  display: flex;
  align-items: center;
  justify-content: center;
}
/* grid 헤더 텍스트 정렬 */
:deep(.ag-dr-balham .ag-header-cell-label) {
  justify-content: center !important;
  white-space: pre-line;
  font-weight: normal;
  font-size: 0.75rem;
}
/* 전체 grid 헤더 텍스트 정렬 */
:deep(.all-grid .ag-header-cell-label) {
  justify-content: center !important;
  font-weight: normal;
  font-size: 0.625rem;
}

:deep(.ag-dr-balham .ag-cell) {
  font-size: 0.625rem;
  text-align: left;
  /* padding-right: 3px; */
}

:deep(.achievement-grid .ag-cell) {
  font-size: 0.75rem;
  text-align: right;
  /* padding-right: 3px; */
}

:deep(.highlight-cell) {
  background-color: #ff8080 !important;
  font-weight: bold;
}

/* 깜빡임이 필요한 셀의 기본 스타일 */
:deep(.needs-blinking) {
  transition: background-color 0.1s ease; /* 부드러운 색상 전환 효과 */
}
/* 깜빡임 활성 상태 스타일 */
:deep(.needs-blinking.blink-on) {
  background-color: #ff0000 !important; /* 빨간색 */
}

/* 1024px 초과일 때 폰트/행 높이 증가 */
@media (min-width: 1025px) {
  :deep(.ag-dr-balham .ag-cell) {
    font-size: 0.8rem;
  }
  :deep(.ag-pr-balham .ag-header-cell-text) {
    font-size: 0.8rem;
  }
  :deep(.achievement-grid .ag-cell) {
    font-size: 0.9rem;
  }
}
</style>
